import { api } from './api';

export interface AlertPreferencesResponse {
  success: boolean;
  data: {
    alertsEnabled: boolean;
    user: {
      id: string;
      name: string;
      phone?: string;
    };
  };
  message?: string;
}

export const userPreferencesService = {
  /**
   * Get user alert preferences
   */
  async getAlertPreferences(): Promise<AlertPreferencesResponse> {
    const response = await api.get<AlertPreferencesResponse>('/user-preferences/alerts');
    return response.data;
  },

  /**
   * Toggle alert preferences (enable/disable alerts)
   */
  async toggleAlertPreferences(alertsEnabled: boolean): Promise<AlertPreferencesResponse> {
    const response = await api.put<AlertPreferencesResponse>('/user-preferences/alerts/toggle', {
      alertsEnabled,
    });
    return response.data;
  },
};

export default userPreferencesService;
